import { render } from "./Control_Charts.vue?vue&type=template&id=f4c3e524&scoped=true"
import script from "./Control_Charts.vue?vue&type=script&lang=js"
export * from "./Control_Charts.vue?vue&type=script&lang=js"

import "./Control_Charts.vue?vue&type=style&index=0&id=f4c3e524&lang=stylus&scoped=true"

import exportComponent from "../../../../../ag-v3-system/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c3e524"]])

export default __exports__